import {PageHeader, TabsComponent} from '@/components/molecules';
import {FONT_SIZE} from '@/utils/constants/globalStyle';
import {
  OverviewTab,
  TierConfigurationsTab,
  TierTab
} from '@/containers/ClubPlus/Tabs';
import {useIntl} from 'react-intl';
import {useActiveTiers} from '@/containers/ClubPlus/hooks/useActiveTiers';
import {useSearchParams} from 'react-router-dom';
import './_home.scss';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {selectCountryCode} from '@/store/slices/countryCodeSlice';
import {showTierConfigurationsFeature} from '@/utils/marketFeatures';

const TAB_INDEX_MAP = {
  overview: 0,
  'tier-configurations': 1
};

export const ClubPlusHome = () => {
  const {formatMessage} = useIntl();
  const {tiers} = useActiveTiers();
  const [searchParams] = useSearchParams();
  const countryCode = useSelector(selectCountryCode);
  const [resetPageIndexFlag, setResetPageIndexFlag] = useState(0);

  const handleTabChange = () => {
    setResetPageIndexFlag((flag) => flag + 1);
  };

  const overviewTab = [
    {
      id: 'overview',
      tabLabel: formatMessage({id: 'CLUB_PLUS.TIER_OVERVIEW_TAB_LABEL'}),
      title: formatMessage({id: 'CLUB_PLUS.TIER_OVERVIEW_TAB_LABEL'}),
      tabComponent: <OverviewTab />
    }
  ];

  const autoEdit = searchParams.get('edit') === 'true';

  const tierConfigurationsTab = [
    {
      id: 'tier-configurations',
      tabLabel: formatMessage({id: 'CLUB_PLUS.TIER_CONFIGURATIONS_TAB_LABEL'}),
      title: formatMessage({id: 'CLUB_PLUS.TIER_CONFIGURATIONS_TAB_LABEL'}),
      tabComponent: <TierConfigurationsTab autoEdit={autoEdit} />
    }
  ];

  const tierTabs = tiers
    ? tiers.map((tier) => ({
        id: tier.name.toLowerCase(),
        tabLabel: tier.name,
        title: tier.name,
        tabComponent: (
          <TierTab
            key={`${tier.tierID}-${resetPageIndexFlag}`}
            tierID={tier.tierID}
            tierName={tier.name}
          />
        )
      }))
    : [];

  const tabList = [
    ...overviewTab,
    ...(showTierConfigurationsFeature(countryCode)
      ? tierConfigurationsTab
      : []),
    ...tierTabs
  ];

  const defaultTabIndex = TAB_INDEX_MAP[searchParams.get('tab')] ?? 0;

  return (
    <section className='clubPlusHomeContainer'>
      <div className='header-style'>
        <PageHeader
          title={formatMessage({id: 'CLUB_PLUS.TITLE'})}
          fontSize={FONT_SIZE.XXXL}
        />
      </div>
      <TabsComponent
        tabList={tabList}
        onTabChange={handleTabChange}
        defaultTabIndex={defaultTabIndex}
      />
    </section>
  );
};
